import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";
import Button from "../Buttons/Button";
import { useSimilarAnswersContext } from "./SimilarAnswersContext";

// Shown after the user has reviewed all suggestions in the current batch. Offers to
// fetch a new batch via onReset.
const SimilarAnswersReviewedPrompt = ({ onReset }) => {
  const { contributionIds } = useSimilarAnswersContext();

  const t = useFormatMessage();
  const count = contributionIds.length;
  const suggestionTitle = t(intlMessages.suggestionTitle, { count });
  const reviewDescription = t(intlMessages.reviewDescription);
  const resetSuggestionsReviewLabel = t(intlMessages.resetSuggestionsReview);

  return (
    <>
      <h2 className="text-success text-subtitle-section margin-bottom-xs">
        {suggestionTitle}
      </h2>

      <p className="text-small text-muted margin-bottom-xs">{reviewDescription}</p>

      <Button
        type="button"
        className="btn btn-primary-inverse btn-sm"
        onClick={onReset}
        label={resetSuggestionsReviewLabel}
      />
    </>
  );
};

export default SimilarAnswersReviewedPrompt;

const intlMessages = defineMessages({
  suggestionTitle: {
    id: "similarAnswers.suggestionTitle",
    defaultMessage:
      "{count, plural, one {# contribution en rapport trouvée} other {# contributions en rapport trouvées}}"
  },
  reviewDescription: {
    id: "similarAnswers.reviewDescription",
    defaultMessage: `Vous avez consulté toutes les suggestions. Vous pouvez reprendre la
      rédaction de votre contribution, et si vous souhaitez voir d'autres suggestions,
      vous pouvez cliquer sur le bouton ci-dessous pour en chercher de nouvelles.`
  },
  resetSuggestionsReview: {
    id: "similarAnswers.resetSuggestionsReview",
    defaultMessage: "Chercher de nouvelles suggestions"
  }
});
